/* Nutri Peak - cart drawer behaviour.

   Two jobs:

   1. UPSELL ROW. The theme initialises Swiper on
      .cart_upsell_items once at page load. The drawer markup is
      replaced whenever the cart changes or the drawer opens, and
      the replacement is never re-initialised, so el.swiper is
      undefined, the track collapses and the extra products
      become unreachable. np-cart.css rebuilds the row as a
      native scroll-snap strip, which needs no JS. The only thing
      script has to do is tell Lenis (the site's smooth-scroll
      library) to keep its hands off the horizontal drag - and
      re-tell it after each re-render.

   2. SAVINGS LINE. Renders "You save  -GBP x.xx" directly above
      the subtotal, in the drawer and on the cart page. Labelled
      "You save" rather than "Discount" because the discount CODE
      field sits directly above it and two rows both reading
      "Discount" is confusing.

      The AJAX cart does not expose compare_at_price, so the
      per-variant compare price is fetched from
      /products/<handle>.js (once per handle, then cached) and
      added to cart.total_discount.
*/

(function () {
  var productCache = {};
  var lastRendered = null;
  var busy = false;

  var LABEL = 'You save';

  function money(pennies) {
    return '£' + (pennies / 100).toFixed(2);
  }

  /* ---------- 1. upsell row ---------- */

  function mark() {
    var rows = document.querySelectorAll('.cart_upsell_items');
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].hasAttribute('data-lenis-prevent')) {
        rows[i].setAttribute('data-lenis-prevent', '');
      }
    }
  }

  /* ---------- 2. savings line ---------- */

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : { variants: [] }; })
      .catch(function () { return { variants: [] }; })
      .then(function (p) { productCache[handle] = p; return p; });
  }

  function totalSaving(cart) {
    var handles = [];
    cart.items.forEach(function (i) {
      if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });

    return Promise.all(handles.map(getProduct)).then(function () {
      // Discount codes and automatic discounts.
      var total = cart.total_discount || 0;

      // Plus the compare-at saving on anything on offer.
      cart.items.forEach(function (item) {
        var p = productCache[item.handle];
        if (!p || !p.variants) return;
        var v = null;
        for (var k = 0; k < p.variants.length; k++) {
          if (p.variants[k].id === item.variant_id) { v = p.variants[k]; break; }
        }
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          total += (v.compare_at_price - v.price) * item.quantity;
        }
      });

      return total;
    });
  }

  function subtotalNodes() {
    var out = [];
    var drawer = document.querySelector('#cart_drawer .cart_drawer_items_subtotals');
    if (drawer) out.push(drawer);
    var page = document.querySelector('.main_cart__items_footer .main_cart__items_subtotals');
    if (page) out.push(page);
    return out;
  }

  function paint(saving) {
    subtotalNodes().forEach(function (subtotal) {
      var footer = subtotal.parentNode;
      if (!footer) return;
      var line = footer.querySelector(':scope > .np-save');

      if (saving <= 0) {
        if (line) line.parentNode.removeChild(line);
        return;
      }

      if (!line) {
        line = document.createElement('div');
        line.className = 'np-save';
        line.innerHTML =
          '<span class="np-save__label"></span><span class="np-save__val"></span>';
        footer.insertBefore(line, subtotal);
      }

      var label = line.querySelector('.np-save__label');
      var val = line.querySelector('.np-save__val');
      var text = '-' + money(saving);
      if (label.textContent !== LABEL) label.textContent = LABEL;
      if (val.textContent !== text) val.textContent = text;
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(totalSaving)
      .then(function (saving) {
        // Only touch the DOM when the number actually changed, so
        // the MutationObserver below cannot feed itself.
        if (saving !== lastRendered || !document.querySelector('.np-save')) {
          lastRendered = saving;
          paint(saving);
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* ---------- wiring ---------- */

  function tick() {
    mark();
    refresh();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    tick();

    var target = document.getElementById('cart_drawer') || document.body;
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(tick, 150);
      }).observe(target, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.header_cart, .drawer_open_btn, [data-cart-open]')) {
        setTimeout(tick, 400);
        setTimeout(tick, 1000);
      }
    });
  });
})();
